import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UnsubscribeOnDestroyAdapter } from '../../../_shared';
import { ClienteResponse } from '../../../_infrastructure/dtos/core/cliente/ClienteResponse';
import { ClienteContextService } from '../../../_infrastructure/context-service/cliente/cliente-context.service';

@Component({
  selector: 'app-transparencia-footer',
  templateUrl: './transparencia-footer.component.html',
  styleUrls: ['./transparencia-footer.component.css'],
  standalone: false
})
export class TransparenciaFooterComponent extends UnsubscribeOnDestroyAdapter implements OnInit {
  cliente!: ClienteResponse;

  constructor(
    private readonly clienteContext: ClienteContextService,
    private readonly cdr: ChangeDetectorRef
  ) { super(); }

  ngOnInit(): void {
    this.subs.sink = this.clienteContext
      .getCliente()
      .subscribe(cliente => {
        this.cliente = cliente;
      });
  }
}
